import React from 'react';
import ReactDOM from 'react-dom/client';

import './styles/index.css';
import App from './components/app';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// NOTE: StrictMode causes 2 renders in order to detect any problems with the code and warn about them
// NOTE: StrictMode does not cause multiple renders in the production build
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
